import { createContext, useContext } from "react";

import type { Terminal } from "~/providers/terminal-provider";

interface TerminalContext {
  terminals: Terminal[];
}

export const TerminalContext = createContext<TerminalContext | undefined>(
  undefined,
);

export const useTerminal = () => {
  const context = useContext(TerminalContext);

  if (!context) {
    throw new Error("useTerminal must be used within a TerminalProvider");
  }
  return context;
};
